import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquery-inclusion-module',
	templateUrl:'./JQueryInclusionModulePluginCompPage.html',
	styles: [],
	styleUrls:['./JQueryInclusionModulePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQueryInclusionModulePluginCompPage
{
	mdContent_1033 = `\`\`\`java
import com.jwebmp.plugins.jquery.JQueryInclusionModule;
\`\`\``;
	mdContent_1034 = `\`\`\`java
JQueryInclusionModule()
\`\`\``;
	mdContent_1035 = `\`\`\`java
// No code needed — JQueryInclusionModule is discovered
// via ServiceLoader and includes the jQuery module
// in Guice classpath scanning automatically.
\`\`\``;
}
